// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"D5-z","displaySixCardTiles":"E5-z"};